import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_ENGAGEMENT_PWA_ENABLED = createFcmConfig('engagement_pwa_enabled', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
